// extracted by mini-css-extract-plugin
export default {"rating":"sN-z","numberOfStars":"tN-z","count":"uN-z","barGraphSpacing":"vN-z","barGraph":"wN-z"};